var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UserAgentApplication } from 'msal/lib-commonjs/UserAgentApplication';
import { Config } from '../../config/config';
import { AZURE_B2C_CANCEL_ERROR, AZURE_B2C_BADREQUEST_ERROR } from '../../shared/types/constants';
import { services } from './services';
var isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
var isPassed = false;
var isAdmin = sessionStorage.getItem('isAdmin');
if (isAdmin === null || isAdmin === '') {
    var urlParams = new URLSearchParams(window.location.search);
    var requestData = urlParams.get('request');
    isAdmin === (requestData != null && requestData != '' ? 'true' : 'false');
    sessionStorage.setItem('isAdmin', isAdmin);
    sessionStorage.setItem('urlEncryData', requestData);
}
var B2CPOLICY = isAdmin === 'true' ? Config.b2CPolicyAdmin : ((sessionStorage.getItem('urlEncryData') == 'null' || sessionStorage.getItem('urlEncryData') == '' ? Config.b2CPolicy : Config.b2CPolicyAdmin));
var MsalUserAgent = new UserAgentApplication({
    auth: {
        clientId: Config.clientId || '',
        authority: "https://".concat(Config.domainUrl, "/").concat(Config.tenantUrl, "/").concat(B2CPOLICY),
        validateAuthority: false,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE,
    },
});
var MsalGlobalUserAgent = new UserAgentApplication({
    auth: {
        clientId: Config.clientId || '',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE,
    },
});
var userAgentApplication = MsalUserAgent;
var authenticationToken = undefined;
var getAppScope = function (scopes) {
    var _a;
    return (_a = scopes === null || scopes === void 0 ? void 0 : scopes.map(function (scope) { return "https://".concat(Config.tenantUrl, "/").concat(Config.clientId, "/").concat(scope); })) !== null && _a !== void 0 ? _a : [];
};
userAgentApplication.handleRedirectCallback(function (error, response) {
    var _a, _b, _c, _d, _e;
    if (error) {
        console.log(error);
        if (error.errorMessage.includes(AZURE_B2C_BADREQUEST_ERROR)) {
            userAgentApplication.acquireTokenRedirect({
                scopes: getAppScope((_a = Config.scopes) === null || _a === void 0 ? void 0 : _a.split(',')),
            });
        }
        else if (error.errorMessage.includes(AZURE_B2C_CANCEL_ERROR)) {
            window.location.href = window.location.origin;
            return;
        }
    }
    if (!(response === null || response === void 0 ? void 0 : response.accessToken)) {
        if (((_d = (_c = (_b = response === null || response === void 0 ? void 0 : response.idToken) === null || _b === void 0 ? void 0 : _b.claims) === null || _c === void 0 ? void 0 : _c.isForgotPassword) === null || _d === void 0 ? void 0 : _d.toString()) == 'true') {
            userAgentApplication.logout();
        }
        else {
            userAgentApplication.acquireTokenRedirect({
                scopes: getAppScope((_e = Config.scopes) === null || _e === void 0 ? void 0 : _e.split(',')),
            });
        }
    }
    authenticationToken = response;
    isPassed = true;
});
var useGlobal = function () {
    userAgentApplication = MsalGlobalUserAgent;
};
var getTokenSilent = function (targetScopes) {
    var _a;
    if (userAgentApplication.getLoginInProgress() || isPassed)
        return authenticationToken;
    return userAgentApplication
        .acquireTokenSilent({
        scopes: targetScopes || getAppScope((_a = Config.scopes) === null || _a === void 0 ? void 0 : _a.split(',')),
    })
        .catch(function () {
        signIn(targetScopes);
    })
        .then(function (result) {
        authenticationToken = result;
        return result;
    });
};
var signIn = function (targetScopes) {
    var _a;
    if (userAgentApplication.getLoginInProgress())
        return;
    userAgentApplication.loginRedirect({
        scopes: targetScopes || getAppScope((_a = Config.scopes) === null || _a === void 0 ? void 0 : _a.split(',')),
        prompt: 'consent',
    });
};
var signOut = function () {
    sessionStorage.clear();
    userAgentApplication.logout();
};
var getBrokerId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!(authenticationToken === undefined ||
                    (authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.uniqueId.length) < 1 ||
                    authenticationToken.expiresOn.getTime() <= new Date(new Date().toUTCString()).getTime())) return [3 /*break*/, 2];
                return [4 /*yield*/, getTokenSilent()];
            case 1:
                _c.sent();
                _c.label = 2;
            case 2:
                if (!(isAdmin === 'true')) return [3 /*break*/, 4];
                return [4 /*yield*/, services.GetDecrypt(sessionStorage.getItem('urlEncryData')).then(function (result) {
                        var _a;
                        if (result.data) {
                            sessionStorage.setItem('guuid', (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.brokerGuid);
                        }
                    })];
            case 3:
                _c.sent();
                //return 'F22140C6-202B-4EAE-BD00-D0B208403CCE';
                return [2 /*return*/, sessionStorage.getItem('guuid')];
            case 4: return [2 /*return*/, (authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.uniqueId.length) < 1
                    ? (_b = (_a = authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.account) === null || _a === void 0 ? void 0 : _a.accountIdentifier) !== null && _b !== void 0 ? _b : ''
                    : authenticationToken.uniqueId];
        }
    });
}); };
var getUserName = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (authenticationToken === undefined ||
        (authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.uniqueId.length) < 1 ||
        authenticationToken.expiresOn.getTime() <= new Date(new Date().toUTCString()).getTime())
        getTokenSilent();
    var uEmail = [
        (_c = (_b = (_a = authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.account) === null || _a === void 0 ? void 0 : _a.userName) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '',
        (_e = (_d = authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.idTokenClaims) === null || _d === void 0 ? void 0 : _d.emails[0]) !== null && _e !== void 0 ? _e : '',
        (_h = (_g = (_f = authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.account) === null || _f === void 0 ? void 0 : _f.idTokenClaims) === null || _g === void 0 ? void 0 : _g.emails[0]) !== null && _h !== void 0 ? _h : '',
    ];
    return (_j = uEmail === null || uEmail === void 0 ? void 0 : uEmail.find(function (email) { return email && email.length > 0; })) !== null && _j !== void 0 ? _j : '';
};
var hasToken = function () {
    if (userAgentApplication.urlContainsHash(window.location.hash)) {
        if (userAgentApplication.isCallback(window.location.hash)) {
            userAgentApplication.handleRedirectCallback(function (token) {
                authenticationToken = token;
            }, console.log);
            return true;
        }
    }
    return false;
};
var getToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(!hasToken() || authenticationToken === undefined || shouldRefreshToken())) return [3 /*break*/, 2];
                return [4 /*yield*/, getTokenSilent()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.accessToken];
        }
    });
}); };
var shouldRefreshToken = function () {
    var tokenExpirationTime = authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.expiresOn.getTime();
    var currentTime = new Date(new Date().toUTCString()).getTime();
    var shouldRefresh = tokenExpirationTime - currentTime <= getTokenDuration() / 2;
    if (shouldRefresh) {
        isPassed = false;
    }
    return shouldRefresh;
};
var checkTokenAge = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!shouldRefreshToken()) return [3 /*break*/, 2];
                return [4 /*yield*/, getTokenSilent()];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 3];
            case 2:
                _a = authenticationToken;
                _b.label = 3;
            case 3: return [2 /*return*/, _a];
        }
    });
}); };
var getTokenDuration = function () {
    if ((authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.accessToken) === null || (authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.accessToken) === undefined)
        return 0;
    var accessTokenPayload = getAccessTokenPayload(authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.accessToken);
    var expiration = parseInt(accessTokenPayload === null || accessTokenPayload === void 0 ? void 0 : accessTokenPayload.exp);
    var notBefore = parseInt(accessTokenPayload === null || accessTokenPayload === void 0 ? void 0 : accessTokenPayload.nbf);
    return Math.abs(expiration - notBefore) * 1000;
};
var getAccessTokenPayload = function (accessToken) {
    var base64Url = accessToken.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64)
        .split('')
        .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
    return JSON.parse(jsonPayload);
};
var getAccount = function () {
    var _a;
    var account;
    var accounts = userAgentApplication.getAllAccounts();
    if ((_a = accounts === null || accounts === void 0 ? void 0 : accounts.length) !== null && _a !== void 0 ? _a : 0 > 0)
        account = accounts[0];
    if (account === undefined)
        account = userAgentApplication.getAccount();
    if (account !== undefined && authenticationToken === undefined)
        getTokenSilent();
    return account;
};
var isAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hasAccount;
    return __generator(this, function (_a) {
        hasAccount = userAgentApplication.getAllAccounts().length > 0 || userAgentApplication.getAccount() !== null;
        if (hasAccount)
            hasToken() ? undefined : getTokenSilent();
        return [2 /*return*/, hasAccount && (authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.accessToken) !== null && (authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.accessToken) !== undefined];
    });
}); };
export { getBrokerId, getUserName, getToken, getAccount, useGlobal, signOut, signIn, isAuth, checkTokenAge, getTokenDuration, authenticationToken, };
